import { VERIFICATION_CHANNEL } from "constants/auth";
import styled from "styled-components";

const Body = styled.div`
  // background: red;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

const Title = styled.div`
  // background: red;
  width: 280px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 30px;
  font-weight: 500;
  color: #464646;
  margin-top: 10px;
  text-align: center;
`;

const ContainerDescription = styled.div`
  // background: lightgray;
  width: 280px;
  font-size: 14px;
  color: #7676b6;
  margin-top: 10px;
  margin-bottom: 5px;
`;

const FormContainer = styled.div`
  // background: lavender;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 20px;
  border: solid lavender 2px;
  width: 320px;
  padding: 10px 0;
  gap: 10px;
  margin-bottom: 5px;
`;

const StyledForm = styled.form`
  // background: coral;
  width: 280px;
  // padding-top: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const VerificationChoice = styled.div`
  // background: red;
  display: flex;
  width: 280px;
  gap: 20px;
`;

const ChannelSelector = styled.div`
  display: flex;
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
`;

const ChannelButton = styled.button`
  flex: 1;
  padding: 6px;
  width: 140px;
  border: 0;
  background: ${({ selected }) => selected ? 'pink' : '#fff'};
  cursor: pointer;
`;

const ChannelDisplay = styled.div`
  display: ${({ $show }) => $show ? 'flex' : 'none'};
  flex-direction: column;
  align-items: center;
  width: 100%
`;

const StyledInput = styled.input`
  width: 170px;
  height: 30px;
  box-sizing: border;
  border-radius: 4px;
  border: none;
  background: #eeeeee;

  // outline: none;

  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;

  &::placeholder {
    color: black;
  }

  &:focus {
    color: black;
  }  
`;

const StyledSubmit = styled.input`
  // background: lightblue;
  // width: 100%;
  width:100px;
  height: 30px;
  border-radius: 4px;
  border: none;
  background: pink;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;
  // margin-top: 2px;
  // margin-bottom: 15px;
`;

const VerificationBox = styled.div`
  background: Bisque;
  border-radius: 4px;
  width: 270px;
  display: flex;
  justify-content: start;
  padding: 5px;
  font-size: 15px;
`;

const TimeInfo = styled.div`
  background: lighgray;
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 2px;
`;

const RemainingTime = styled.label`
  color: red;
  padding: 0 4px;
`;

const StatusBar = styled.div`
  // background: pink;
  box-sizing: border-box;  
  width: 280px;
  padding-top: 12px;
  padding-bottom: 10px;
  padding-left: 5px;
  // padding-right: 5px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
`;

const StatusTextButton = styled.div`
  color: blue;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  &:hover {
    background: lightgray;
  }
`;

export const FindAccountVerify = ({
  email,
  mobile,
  channel,
  onSendCode,
  onEmailVerify,
  onMobileVerify,
  onChannelChange,
  onClose,
}) => {
  return (
    <>
      <Body>
        <Title>아이디찾기</Title>

        <ContainerDescription>1. 인증수단 선택</ContainerDescription>
        <FormContainer>
          <VerificationChoice>
            <ChannelSelector>
              <ChannelButton
                selected={channel === VERIFICATION_CHANNEL.EMAIL}
                onClick={() => onChannelChange(VERIFICATION_CHANNEL.EMAIL)}
              >
                이메일
              </ChannelButton>
              <ChannelButton
                selected={channel === VERIFICATION_CHANNEL.MOBILE}
                onClick={() => onChannelChange(VERIFICATION_CHANNEL.MOBILE)}
              >
                휴대폰
              </ChannelButton>
            </ChannelSelector>
          </VerificationChoice>
        </FormContainer>

        <ChannelDisplay $show={channel === VERIFICATION_CHANNEL.EMAIL}>
          <ContainerDescription>2. 이메일로 인증하기</ContainerDescription>
          <FormContainer>
            <StyledForm onSubmit={e => onSendCode(e, email)}>
              <StyledInput ref={email.targetRef} placeholder=" 이메일주소 입력" />
              <StyledSubmit type="submit" value={email.codeSent ? '재전송' : '인증번호전송'} />
            </StyledForm>
            <StyledForm onSubmit={onEmailVerify}>
              <StyledInput ref={email.codeRef} placeholder=" 인증번호" />
              <StyledSubmit type="submit" value="아이디찾기" />
            </StyledForm>
            {email.running && (
              <VerificationBox>
                <TimeInfo>
                  남은시간<RemainingTime>{email.remainingTime}</RemainingTime>
                </TimeInfo>
              </VerificationBox>
            )}
          </FormContainer>
        </ChannelDisplay>

        <ChannelDisplay $show={channel===VERIFICATION_CHANNEL.MOBILE}>
          <ContainerDescription>2. 휴대폰으로 인증하기</ContainerDescription>
          <FormContainer>
            <StyledForm onSubmit={e => onSendCode(e, mobile)}>
              <StyledInput ref={mobile.targetRef} placeholder=" 휴대폰번호 입력" />
              <StyledSubmit type="submit" value={mobile.codeSent ? "재전송" : "인증번호전송"} />
            </StyledForm>
            <StyledForm onSubmit={onMobileVerify}>
              <StyledInput ref={mobile.codeRef} placeholder=" 인증번호" />
              <StyledSubmit type="submit" value="아이디찾기" />
            </StyledForm>
            {mobile.running && (
              <VerificationBox>
                <TimeInfo>
                  남은시간<RemainingTime>{mobile.remainingTime}</RemainingTime>
                </TimeInfo>
              </VerificationBox>
            )}
          </FormContainer>
        </ChannelDisplay>
        
      </Body>
      <StatusBar>
        <StatusTextButton onClick={onClose}>닫기</StatusTextButton>
      </StatusBar>
    </>      
  );
};